"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var TemplateRating32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("path", { d: "M13 0c7.18 0 13 4.925 13 11s-5.82 11-13 11c-1.531 0-3-.224-4.365-.635l-1.803 1.803C5.268 24.732 4 24.213 4.002 21.993V18.94C1.537 16.938 0 14.12 0 11 0 4.925 5.82 0 13 0zm0 1C6.339 1 1 5.518 1 11c0 2.724 1.318 5.285 3.633 7.163a1 1 0 01.37.777L5 21.993c0 1.326.188 1.404 1.124.468l1.803-1.803a1 1 0 01.996-.25c1.295.39 2.668.592 4.076.592 6.661 0 12-4.518 12-10S19.661 1 13 1zM6.07 11.52a.5.5 0 01.624.331c.773 2.53 2.92 4.399 6.306 4.399 3.38 0 5.525-1.861 6.302-4.387a.5.5 0 01.956.294C19.36 15.076 16.854 17.25 13 17.25c-3.86 0-6.37-2.182-7.262-5.107a.5.5 0 01.332-.624z", id: "template-rating-32_svg__a" })),
    react_1.default.createElement("g", { transform: "translate(3 4)", fill: "currentColor", fillRule: "evenodd" },
        react_1.default.createElement("mask", { id: "template-rating-32_svg__b" },
            react_1.default.createElement("use", { xlinkHref: "#template-rating-32_svg__a" })),
        react_1.default.createElement("use", { fillRule: "nonzero", xlinkHref: "#template-rating-32_svg__a" }),
        react_1.default.createElement("g", { mask: "url(#template-rating-32_svg__b)" },
            react_1.default.createElement("path", { d: "M-3-4h32v32H-3z" }))))); };
var StyledTemplateRating32 = styled_components_1.default(TemplateRating32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledTemplateRating32;
var templateObject_1;
//# sourceMappingURL=TemplateRating32.js.map